var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 34,
    viewBox: "0 0 132 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.333 23.3943C25.7975 28.8845 20.8188 33.0248 14.4903 33.0248C6.20768 33.025 0.949707 26.6516 0.949707 19.6264C0.949707 12.1361 6.67314 6.22803 14.2577 6.22803C20.3069 6.22803 25.7513 9.94969 27.333 16.0441H22.3541C21.0514 12.6482 17.8872 10.741 14.4441 10.741C11.8846 10.6943 10.0233 11.5314 8.25516 13.2065C6.76608 14.6953 5.78894 17.0678 5.78894 19.6267C5.78894 24.8371 9.60457 28.5123 14.4441 28.5123C18.6784 28.4656 21.3305 25.9074 22.3541 23.3945H27.333V23.3943Z",
    fill: "#FFFBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8229 32.186H53.1763V27.9419C51.4786 31.2032 47.9939 32.9006 44.1515 32.9006C36.3326 32.9006 31.686 26.8253 31.686 20.0357C31.686 12.6207 37.092 7.1709 44.1515 7.1709C48.9766 7.1709 52.0595 9.85148 53.1763 12.1738V7.88574H57.8229V32.186ZM36.3326 20.1256C36.377 23.7435 38.9241 28.5676 44.8215 28.5676C48.5298 28.5676 51.1657 26.5125 52.3722 23.7435C52.9084 22.6269 53.1766 21.3758 53.2213 20.1256C53.2657 18.8745 53.0425 17.6238 52.5063 16.5065C51.3445 13.6926 48.6192 11.5041 44.7318 11.5041C39.6388 11.5041 36.3323 15.5245 36.3323 20.0807V20.1256H36.3326Z",
    fill: "#FFFBEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0386 0.0249023H68.749V17.9656L78.0486 8.5805H83.5498L72.9839 19.013L83.8554 32.3268H78.5724L68.749 20.104V32.3265H64.0386V0.0249023Z",
    fill: "#FFFBEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.726 8.58234H124.005V12.0745C125.358 9.28077 127.847 7.42284 131.077 7.37891V11.9189H130.772C126.619 12.1593 124.267 14.7803 124.267 19.4951V32.3283H119.726V8.58234H119.726Z",
    fill: "#FFFBEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 16.697H88.7815V12.6405L95.7015 10.5288L113.16 12.6405V16.697Z",
    fill: "#FFFBEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 20.2012H88.7815V24.1907H113.16V20.2012Z",
    fill: "#FFFBEF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 27.6953H88.7815V31.6849H113.16V27.6953Z",
    fill: "#FFFBEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.012 8.38657C102.461 8.38657 103.635 7.21277 103.635 5.76482C103.635 4.31686 102.461 3.14307 101.012 3.14307C99.5642 3.14307 98.3901 4.31686 98.3901 5.76482C98.3901 7.21277 99.5642 8.38657 101.012 8.38657Z",
    fill: "#FFFBEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLogo);
export default __webpack_public_path__ + "static/media/TopLogo.a65cc9f1865d2acc9296294180d32789.svg";
export { ForwardRef as ReactComponent };